import parse from 'html-react-parser';

export default function createElementFromHTML(htmlString: string): string | JSX.Element | JSX.Element[] {
    return parse(htmlString);
}
